var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.amenityName)?_c('li',{staticClass:"floor__info__amenity--directory",class:_vm.customClasses},[_c(`${_vm.derivedAmenityName}Icon`,{tag:"component"})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }